export const FileTypes = {
  DOCUMENT: ['dokument', 'image'],
  PAGE: ['pagelink']
};
